import React, { useEffect } from 'react';
import Prism from 'prismjs';
import { Icons } from './Icons';

interface CodeBlockProps {
  code: string;
  language: string;
}

const CodeBlock: React.FC<CodeBlockProps> = ({ code, language }) => {
  const [copied, setCopied] = React.useState(false);

  useEffect(() => {
    Prism.highlightAll();
  }, [code]);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative group rounded-lg overflow-hidden bg-[#2d2d2d]">
      <button
        onClick={handleCopy}
        className="absolute top-2 right-2 p-2.5 rounded-md bg-white/10 hover:bg-white/20 text-white transition-all opacity-90 md:opacity-0 md:group-hover:opacity-100 min-h-[44px] min-w-[44px] flex items-center justify-center"
        title="Copy code"
      >
        {copied ? <Icons.Check size={18} /> : <Icons.Copy size={18} />}
      </button>
      <pre className="!m-0 !p-4 !bg-transparent overflow-auto max-h-[500px] text-sm sm:text-base">
        <code className={`language-${language}`}>{code}</code>
      </pre>
    </div>
  );
};

export default CodeBlock;
